import React, { useState } from 'react'
import get from 'lodash/get'

import Apartment from '../../assets/svgs/Apartment'
import House from '../../assets/svgs/House'
import Mic from '../../assets/svgs/Mic'
import Company from '../../assets/svgs/Company'
import Area from '../../assets/svgs/details/area'
import Shower from '../../assets/svgs/details/shower'
import Bed from '../../assets/svgs/details/bed'
import ParkingSpots from '../../assets/svgs/ParkingSpots'
import Arrow from '../../assets/svgs/Arrow'

import { currencyFloatToString } from '../../helpers/currency'

import { PropertyValues, PropertyTetantPays, PropertyInfo } from 'types/propertyAnnouncement'
import { Image } from 'types/image'
import COLORS from '../../styles/colors'
import './styles.scss'

interface Props {
  propertyImages: Image[]
  landlordImage: {
    name: string
    profile_image: Image
  }
  values: PropertyValues
  tenantPays: PropertyTetantPays
  details: PropertyInfo
}

const AnnouncementCard = ({
  details,
  landlordImage,
  propertyImages,
  values,
  tenantPays,
}: Props) => {
  const [currentPicture, setPicture] = useState(0)

  const handleChangeImage = (forward: boolean) => {
    if (forward) {
      if (currentPicture + 1 < propertyImages.length) {
        setPicture(currentPicture + 1)
      }
      return
    }

    if (currentPicture - 1 >= 0) {
      setPicture(currentPicture - 1)
    }
  }

  const getCard = () => {
    switch (details.type) {
      case 'apartment':
        return (
          <>
            <Apartment
              color={COLORS.gray}
              style={{ width: 25, height: 25, transform: 'translateY(3px)' }}
            />
            <div>
              <p>Tipo: </p>
              <p>APÊ</p>
            </div>
          </>
        )
      case 'house':
        return (
          <>
            <House
              color={COLORS.gray}
              style={{ width: 25, height: 25, transform: 'translateY(3px)' }}
            />
            <div>
              <p>Tipo: </p>
              <p>CASA</p>
            </div>
          </>
        )
      default:
        return (
          <>
            <div style={{ width: 33, height: 33 }}>
              <Company color={COLORS.gray} />
              <Mic color={COLORS.gray} />
            </div>
            <div>
              <p>Tipo: </p>
              <p>Estúdio/Kitnet</p>
            </div>
          </>
        )
    }
  }

  const otherValues = (() => {
    const total = Object.keys(tenantPays).reduce((a, b) => (tenantPays[b] ? values[b] + a : a), 0)
    const other = values.rent - total

    return other >= 0 ? other : 0
  })()

  const userImage = get(
    landlordImage,
    'small.url',
    `https://ui-avatars.com/api/?name=${landlordImage.name}&size=512&&color=FFFFFF&background=4486F8`,
  )

  return (
    <div className='annoucement-card-container'>
      <div className='images-container'>
        <img
          className='property-image'
          src={propertyImages[currentPicture].small.url}
          alt='property'
        />
        <div onClick={() => handleChangeImage(false)} className='arrow-container left'>
          {currentPicture - 1 >= 0 && <Arrow />}
        </div>
        <div onClick={() => handleChangeImage(true)} className='arrow-container'>
          {currentPicture + 1 < propertyImages.length && <Arrow />}
        </div>
        <div className='info-stripe'>
          <div className='main-info__announcement-card'>
            <div className='picture-container__announcement-card'>
              <img src={userImage} alt='profile' />
            </div>
            <div className='content-container__announcement-card'>
              <p>São Franscisco, Curitiba</p>
              <span>{currencyFloatToString(values.rent)}</span>
            </div>
          </div>
          <div className='others__announcement-card'>
            <p>Condomínio e Outros</p>
            <span>{currencyFloatToString(otherValues)}</span>
          </div>
        </div>
      </div>
      <div className='property-details'>
        <div className='svg-container__announcement-card'>{getCard()}</div>
        <div className='svg-container__announcement-card'>
          <Area
            color={COLORS.gray}
            style={{ width: 23, height: 23, transform: 'translateY(3px)' }}
          />
          <div>
            <p>Área: </p>
            <p>{`${details.area}m²`}</p>
          </div>
        </div>
        <div className='svg-container__announcement-card'>
          <Shower color={COLORS.gray} style={{ width: 27, height: 27 }} />
          <div>
            <p>Banheiros </p>
            <p>{details.bathrooms}</p>
          </div>
        </div>
        <div className='svg-container__announcement-card'>
          <Bed
            color={COLORS.gray}
            style={{ width: 25, height: 25, transform: 'translateY(5px)' }}
          />
          <div>
            <p>Quartos</p>
            <p>{`${details.rooms}`}</p>
          </div>
        </div>
        <div className='svg-container__announcement-card'>
          <ParkingSpots color={COLORS.gray} style={{ width: 29, height: 29 }} />
          <div>
            <p>Vagas </p>
            <p>{details.car_slots}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AnnouncementCard
